module.exports = __webpack_public_path__ + "static/media/logo.abfeef73.png";